import type { AppLolRegion, AppRegion } from "@core-types/region.enum";
import type { IRegionStrategy } from "../IRegionStrategy";
import LolRegionHelper from "../LolRegionHelper";

export class LolRegionStrategy implements IRegionStrategy {
  get defaultRegion(): AppRegion {
    return LolRegionHelper.DEFAULT_REGION;
  }

  getAllInfo() {
    return LolRegionHelper.getAllInfo();
  }

  getInfoByCode(code: AppRegion) {
    return LolRegionHelper.getInfoByCode(code as AppLolRegion);
  }

  getRegionHref(currentPath: string, targetRegionCode: AppRegion): string {
    return LolRegionHelper.getRegionHref(
      currentPath,
      targetRegionCode as AppLolRegion,
    );
  }

  convertToRegionEnum(region: string): AppRegion {
    return LolRegionHelper.convertToRegionEnum(region);
  }
}
